module.exports = __webpack_public_path__ + "img/company.83b3b4cf.png";